import styled from 'styled-components'

const baseUrl = process.env.REACT_APP_CDN_IMG + '/img_static/img/_v5/m/sprites/'

export const CateIcon = styled.div`
    .cate_icon_bg {
        display: inline-block;
        background-image: url(${`${baseUrl}category.png`});
        background-repeat: no-repeat;
        background-size: ${(props) => 1054 / props.size}px ${(props) => 80 / props.size}px;
    }
    .bg-0000000101 {
        width: ${(props) => 52 / props.size}px;
        height: ${(props) => 60 / props.size}px;
        background-position: ${(props) => -80 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000102 {
        width: ${(props) => 70 / props.size}px;
        height: ${(props) => 52 / props.size}px;
        background-position: ${(props) => -882 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000103 {
        width: ${(props) => 72 / props.size}px;
        height: ${(props) => 52 / props.size}px;
        background-position: ${(props) => -972 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000104 {
        width: ${(props) => 56 / props.size}px;
        height: ${(props) => 56 / props.size}px;
        background-position: ${(props) => -226 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000105 {
        width: ${(props) => 68 / props.size}px;
        height: ${(props) => 54 / props.size}px;
        background-position: ${(props) => -706 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000106 {
        width: ${(props) => 62 / props.size}px;
        height: ${(props) => 54 / props.size}px;
        background-position: ${(props) => -458 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000107 {
        width: ${(props) => 54 / props.size}px;
        height: ${(props) => 60 / props.size}px;
        background-position: ${(props) => -152 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000108 {
        width: ${(props) => 56 / props.size}px;
        height: ${(props) => 56 / props.size}px;
        background-position: ${(props) => -302 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000109 {
        width: ${(props) => 50 / props.size}px;
        height: ${(props) => 60 / props.size}px;
        background-position: ${(props) => -10 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000110 {
        width: ${(props) => 68 / props.size}px;
        height: ${(props) => 56 / props.size}px;
        background-position: ${(props) => -794 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000111 {
        width: ${(props) => 64 / props.size}px;
        height: ${(props) => 52 / props.size}px;
        background-position: ${(props) => -622 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000112 {
        width: ${(props) => 62 / props.size}px;
        height: ${(props) => 52 / props.size}px;
        background-position: ${(props) => -540 / props.size}px ${(props) => -10 / props.size}px;
    }

    .bg-0000000113 {
        width: ${(props) => 60 / props.size}px;
        height: ${(props) => 54 / props.size}px;
        background-position: ${(props) => -378 / props.size}px ${(props) => -10 / props.size}px;
    }
`

export const AppStyle = styled.div`
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 14px;
    color: #333;

    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }
`



// WEBPACK FOOTER //
// ./src/m_header/layouts/app/styles.js